export const required = (value) => (value || typeof value === 'number' ? undefined : 'Required');
export const email = (value) =>
  (value && !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) ?
    'Invalid email address' : undefined);
export const autocompleteRequired = (value) => (value && value.length > 0 ? undefined : 'Required');
export const passwordMatch = (value, allValues) => (value !== allValues.password ? 'Passwords don\'t match' : undefined);
